/* eslint-disable import/prefer-default-export */
import * as authReducer from '../reducers/auth';

export const tokenExpired = () => dispatch => {
  dispatch(authReducer.SET_TOKEN_EXPIRY_STATUS(true));
};

export const setToken = data => dispatch => {
  dispatch(authReducer.SET_TOKEN(data));
};

export const logout = () => dispatch => {
  // Optionally: clear localStorage/sessionStorage/token
  localStorage.clear();
  dispatch({ type: 'RESET_STORE' });
};